import { Popover } from '@mui/material';
import { MouseEvent, ReactNode, useEffect, useState } from 'react';

type PopupProps = {
  children: ReactNode;
  anchorElement: (
    onClick: (event: MouseEvent<HTMLElement>) => void
  ) => ReactNode;
  top?: boolean;
  bottom?: boolean;
  left?: boolean;
  right?: boolean;
};

export function Popup({
  children,
  anchorElement,
  top,
  bottom,
  right,
  left,
}: PopupProps) {
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const handleClick = (event: MouseEvent<HTMLElement>) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  useEffect(() => {
    window.addEventListener('click', handleClose);

    return () => {
      window.removeEventListener('click', handleClose);
    };
  }, []);

  return (
    <div>
      {anchorElement(handleClick)}
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: top ? 'top' : bottom ? 'bottom' : 'center',
          horizontal: left ? 'left' : right ? 'right' : 'center',
        }}
      >
        {children}
      </Popover>
    </div>
  );
}
